import {Controller} from "@hotwired/stimulus"

// Record shipment modal: the balance ETA on a row is only editable when the
// quantity being shipped is short of what is still outstanding — a full shipment
// leaves no balance to date.
//
// Replaces an inline :javascript block bound on `shown.bs.modal` at the document
// level, which rebound for every modal opened anywhere on the page.
export default class extends Controller {
    static targets = ["quantity", "eta"]

    connect() {
        this.quantityTargets.forEach((quantity) => this.apply(quantity))
    }

    sync(event) {
        this.apply(event.currentTarget)
    }

    apply(quantity) {
        const row = quantity.closest("tr")
        if (!row) return

        const eta = row.querySelector('[data-shipment-quantities-target="eta"]')
        if (!eta) return

        const remaining = parseInt(row.dataset.remaining, 10)
        const shipped = parseInt(quantity.value, 10) || 0
        const partial = shipped < remaining

        eta.disabled = !partial
        if (!partial) eta.value = ""
    }
}
